import { asFlagId, type FlagId } from "@repo/domain";
import { z } from "zod";
import { newEntityIdSchema } from "./entity-id.schemas";
import { patientRefSchema } from "./patient.schemas";
import { practitionerRefSchema } from "./practitioner.schemas";
import { codeableConceptSchema } from "./schedule.schemas";
import { visitIdSchema } from "./visit.schemas";

const periodSchema = z.object({ start: z.string().optional(), end: z.string().optional() });

export const raiseFlagInputSchema = z.object({
  id: newEntityIdSchema,
  patient: patientRefSchema,
  visitId: visitIdSchema.optional(),
  author: practitionerRefSchema.optional(),
  code: codeableConceptSchema,
  category: z.array(codeableConceptSchema).optional(),
  period: periodSchema.optional(),
});
export type RaiseFlagInput = z.infer<typeof raiseFlagInputSchema>;

export const flagIdSchema: z.ZodType<FlagId, z.ZodTypeDef, string> = z.string().min(1).transform(asFlagId);

export const flagIdInputSchema = z.object({ flagId: flagIdSchema });
export type FlagIdInput = z.infer<typeof flagIdInputSchema>;

export const updateFlagInputSchema = z.object({
  flagId: flagIdSchema,
  code: codeableConceptSchema.optional(),
  category: z.array(codeableConceptSchema).optional(),
});
export type UpdateFlagInput = z.infer<typeof updateFlagInputSchema>;
